import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Contact from './pages/Contact';
import About from './pages/About';
import ScrollToTop from './components/ScrollToTop';
import SEO from './components/SEO';

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <RouterRoutes>
          <Route path="/" element={
            <>
              <SEO 
                title="Nuwantha Enterprises - Your Trusted Transport Partner in Sri Lanka"
                description="Book your bus tickets online with Nuwantha Enterprises. Safe, reliable, and comfortable bus services across Sri Lanka. 24+ years of excellence in transportation."
                keywords="bus booking, bus tickets, Sri Lanka transport, online bus booking, Nuwantha Enterprises, bus service, travel Sri Lanka"
                canonical="https://nuwanthaenterprises.com"
              />
              <Dashboard />
            </>
          } />
          <Route path="/about" element={
            <>
              <SEO 
                title="About Us - Nuwantha Enterprises | 24+ Years of Excellence"
                description="Learn about Nuwantha Enterprises - Your trusted transport partner in Sri Lanka since 2000. Safe, reliable, and comfortable bus services with modern fleet and professional drivers."
                keywords="about Nuwantha Enterprises, bus company Sri Lanka, transport company, bus service history, reliable transport"
                canonical="https://nuwanthaenterprises.com/about"
              />
              <About />
            </>
          } />
          <Route path="/contact" element={
            <>
              <SEO 
                title="Contact Us - Nuwantha Enterprises | Get in Touch"
                description="Contact Nuwantha Enterprises for bus bookings, inquiries, or support. Phone: 07777 500 22, Email: info@nuwantha.lk. 24/7 customer support available."
                keywords="contact Nuwantha Enterprises, bus booking contact, customer support, transport inquiry, phone number, email"
                canonical="https://nuwanthaenterprises.com/contact"
              />
              <Contact />
            </>
          } />
        </RouterRoutes>
      </Layout>
    </>
  );
}

export default App; 